import React from 'react';
import bannerHeroImg from './assets/preview-banner-hero.png';
import zeroRupeeImg from './assets/homepage-mobile-zero.png';
import styles from './styles/ConvenienceFeeHomepageSearchBanner.module.css';

const ARIA_LABEL = '₹0 Convenience Fee on all Domestic flights';
const PROMO_COPY = 'Convenience Fee on all Domestic flights';

/**
 * Inline promo on flight homepage search widget.
 * Desktop: Figma 6780:59002 — Special Fares row (right).
 * Mobile: Figma 6931:40497 — below Let's Go.
 * @param {'desktop' | 'mobile'} variant
 */
export default function ConvenienceFeeHomepageSearchBanner({ variant = 'desktop' }) {
  if (variant === 'mobile') {
    return (
      <div className={styles.mobileBanner} role="note" aria-label={ARIA_LABEL}>
        <div className={styles.mobileRow}>
          <img
            className={styles.zeroImg}
            src={zeroRupeeImg}
            alt=""
            draggable={false}
            aria-hidden="true"
          />
          <p className={styles.mobileTitle}>{PROMO_COPY}</p>
          <div className={styles.mobileHeroWrap}>
            <img className={styles.mobileHero} src={bannerHeroImg} alt="" draggable={false} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.desktopBanner} role="note" aria-label={ARIA_LABEL}>
      <div className={styles.promoRow}>
        <div className={styles.promoCopy}>
          <img
            className={styles.zeroImg}
            src={zeroRupeeImg}
            alt=""
            draggable={false}
            aria-hidden="true"
          />
          <p className={styles.desktopTitle}>{PROMO_COPY}</p>
        </div>

        <div className={styles.heroWrap}>
          <img className={styles.heroImg} src={bannerHeroImg} alt="" draggable={false} />
        </div>
      </div>
    </div>
  );
}
